// *******************************************************************************
// Form : Contact Step
// *******************************************************************************
const extraValidateOtherField = (formName, stepIndex) => {
  const otherInputWrapper =
    document.querySelector(`${formName} [data-step="${stepIndex + 1}"] .input--other`) ||
    document.querySelector(`${formName} [data-step-form-step="${stepIndex + 1}"] .input--other`);
  const otherInput = otherInputWrapper?.querySelector('input');
  return !(otherInput && otherInput.required && otherInput.value.trim() === '');
};

const handleContactStepForm = (form, formAction, id) => {
  const formParent = form.closest('[data-parent]');
  const allSteps = formParent.querySelectorAll('[data-step]');
  const allFormSteps = formParent.querySelectorAll('.contact-form__steps-step--form');
  const allContentSteps = formParent.querySelectorAll('.contact-form__steps-step--content');
  const allStepIndicator = formParent.querySelectorAll('.contact-form__indicator-btn');
  const nextButton = formParent.querySelector('.contact-form__next-step');
  const submitButtonText = nextButton.getAttribute(['data-submit-text']);
  const formAlertError = formParent.querySelector('.contact-form__form-alert-error');
  const nextButtonText = nextButton.innerHTML;
  const allForms = [];
  const allStepData = [];

  let currentStepIndex = 0;

  const toggleStep = (index, active) => {
    const step = allFormSteps[index];
    const contentStep = allContentSteps[index];
    const stepIndicator = allStepIndicator[index];

    FormValidation.utils.classSet(step, {
      'is-active': active,
    });
    FormValidation.utils.classSet(contentStep, {
      'is-active': active,
    });
    FormValidation.utils.classSet(stepIndicator, {
      'is-active': true,
    });
  };

  const markCompleted = (index) => {
    const stepIndicator = allStepIndicator[index];
    stepIndicator.classList.add('is-completed');
  };

  const moveNextStep = async () => {
    if (currentStepIndex < allForms.length) {
      const currentForm = allForms[currentStepIndex];
      const status = await currentForm.validate();
      if (status !== 'Valid' || !extraValidateOtherField('#contact-step-form', currentStepIndex)) {
        return;
      }

      let nextIndex = currentStepIndex + 1;

      while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
        nextIndex++;
      }

      if (nextIndex < allFormSteps.length) {
        toggleStep(currentStepIndex, false);
        currentStepIndex = nextIndex;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButton.innerHTML = submitButtonText;
        }
      }
    }
  };

  allFormSteps.forEach((step, index) => {
    const fv = FormValidation.formValidation(step, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox,.radio-button,.dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger({
          event: 'submit',
        }),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        if (e.element.hasAttribute('required')) {
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox,.radio-button,.dropdown');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '' || !e.valid,
          });
        }
      })
      .on('core.form.valid', () => {
        grecaptcha.ready(async () => {
          formParent.classList.add('show-loader');

          try {
            const stepData = getFormValue(step, fv);
            allStepData.push(JSON.parse(stepData.inputs));

            if (index === allFormSteps.length - 1) {
              const inputs = {};

              for (const key in allStepData) {
                if (!isNaN(key)) {
                  Object.assign(inputs, allStepData[key]);
                }
              }

              await onFormSubmit({
                formData: {
                  inputs: JSON.stringify(inputs),
                  lang: localData.lang,
                },
                recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
                recaptchaAction: formAction,
              });

              sendToDataLayer(id);
            }

            formParent.classList.remove('show-loader');
            if (index === allFormSteps.length - 1) {
              formParent.classList.add('show-thankyou');
            } else {
              if (!extraValidateOtherField('#contact-step-form', index)) {
                return;
              }

              toggleStep(index, false);
              if (index + 1 < allFormSteps.length) {
                toggleStep(index + 1, true);
              }
            }
            markCompleted(index);
          } catch (error) {
            console.error(error);
            formParent.classList.remove('show-loader');
            formParent.classList.add('show-error');
            formAlertError.classList.remove('hide');
            formAlertError.innerHTML = error.response.data.data.msg;
          }
        });
      });

    allForms.push(fv);

    attachEvent('.contact-form [data-step="1"] .radio-button-group input', 'change', () => {
      const allInputs = formParent.querySelectorAll('.mod-input,.checkbox');
      allInputs.forEach((inputs) => {
        const inputEle = inputs.querySelector('input,textarea');
        inputEle.value = '';

        if (inputEle.type === 'checkbox') {
          inputEle.checked = false;
        }

        inputs.classList.remove('is-validation-failed');
      });
      fv.resetForm();
    });
  });

  nextButton.addEventListener('click', moveNextStep);

  allStepIndicator.forEach((stepIndicator, index) => {
    stepIndicator.addEventListener('click', () => {
      allSteps.forEach((stepEle) => {
        if (stepEle.classList.contains('hide')) {
          stepEle.classList.remove('is-active');
        }
      });

      if (allFormSteps[index].classList.contains('hide')) {
        allFormSteps.forEach((item) => item.classList.toggle('remove'));
      }

      toggleStep(currentStepIndex, false);
      currentStepIndex = index;
      toggleStep(currentStepIndex, true);
      nextButton.innerHTML = currentStepIndex !== allFormSteps.length - 1 ? nextButtonText : submitButtonText;
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  ['contact-step-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleContactStepForm(form, formAction, id);
    }
  });
});

attachEvent(
  '.contact-form input[name="hear-about-us"], #inquiry-steps-form input[name="hear-about-us"]',
  'change',
  () => {
    const isChecked = document.querySelector('input#other').checked;
    const otherInputWrapper = document.querySelector('.input--other');
    const otherInput = otherInputWrapper.querySelector('input');
    otherInputWrapper.classList.toggle('is-active', isChecked);
    otherInputWrapper.classList.remove('is-validation-failed');
    otherInput.required = isChecked;

    otherInputWrapper.querySelector('.fv-plugins-message-container').innerHTML =
      otherInput.getAttribute('data-fv-not-empty___message');
  },
);

attachEvent('.contact-form .radio-button-group input[name="interest"]', 'change', (ev) => {
  const parentEle = ev.target.closest('.contact-form');

  // Contact Info Render
  const innerEle = ev.target.closest('.radio-button-group__list-item');
  const contactPlaceholder = parentEle.querySelector('.contact-form__contact-placeholder--last');
  const contactInfoEle = innerEle.querySelector('.radio-button-group__contact-info');
  const clonedContact = contactInfoEle?.cloneNode(true);

  contactPlaceholder.innerHTML = '';
  if (contactInfoEle) {
    contactPlaceholder.appendChild(clonedContact);
  }

  // Hide Second Steps
  const twoStepRadio = ev.target.closest('[data-two-step-form]');
  const hideSecondStep = parentEle.querySelectorAll('[data-step="2"]');
  const stepIndicator = parentEle.querySelectorAll('.contact-form__indicator-btn');
  const allSteps = parentEle.querySelectorAll('[data-step]');

  allSteps.forEach((step) => {
    if (!(step.getAttribute('data-step') === '1')) {
      step.classList.remove('is-active');

      if (step.classList.contains('is-completed')) {
        step.classList.remove('is-completed');
      }
    }
  });

  hideSecondStep.forEach((step) => step.classList.toggle('hide', twoStepRadio));

  let visibleIndex = 1;
  stepIndicator.forEach((indicator) => {
    if (!indicator.classList.contains('hide')) {
      // eslint-disable-next-line
      indicator.innerHTML = ('0' + visibleIndex).slice(-2);
      visibleIndex++;
    }
  });
});
